import { useWalletModal } from '@solana/wallet-adapter-ant-design';
import { useWallet } from '@solana/wallet-adapter-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import discord from '../../assets/icons/discord.png';
import handle from '../../assets/icons/header-left.png';
import logo from '../../assets/icons/logo.png';
import twitter from '../../assets/icons/twitter.png';
import { Button } from '../Button';
import {
  BarIcon,
  MobileLogo,
  MobileMenu,
  StyledHeader,
  StyledTools,
} from './style';

export const Navigation = () => {
  const { setVisible: setOpenWalletModal } = useWalletModal();
  const { disconnect, connected, publicKey } = useWallet();
  const [openMobileMenu, setOpenMobileMenu] = useState<Boolean>(false);
  return (
    <>
      <BarIcon>
        <svg
          onClick={() => setOpenMobileMenu(true)}
          viewBox='0 0 100 80'
          width='40'
          height='40'
        >
          <rect width='100' height='20'></rect>
          <rect y='30' width='100' height='20'></rect>
          <rect y='60' width='100' height='20'></rect>
        </svg>
      </BarIcon>

      <MobileLogo>
        <Link to='/' className='logo'>
          <img src={logo} alt='' />
          <p>SOLANA MONKEY UNIVERSITY</p>
        </Link>
      </MobileLogo>

      <MobileMenu style={{ left: openMobileMenu ? '0' : '-500%' }}>
        <svg
          onClick={() => setOpenMobileMenu(false)}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 50 50'
          overflow='visible'
          stroke='white'
          strokeWidth='10'
          strokeLinecap='round'
        >
          <line x2='50' y2='50' />
          <line x1='50' y2='50' />
        </svg>
        <a
          className='item'
          href='https://www.solanamonkeyuniversity.com/#roadmap'
        >
          Roadmap
        </a>
        <a className='item' href='https://www.solanamonkeyuniversity.com/#team'>
          Team
        </a>
        <a
          href='https://www.solanamonkeyuniversity.com/campus'
          className='item'
        >
          CAMPUS
        </a>
        <a
          className='item'
          href='https://www.solanamonkeyuniversity.com/#links'
        >
          LINKS
        </a>
      </MobileMenu>

      {/* main menu */}
      <StyledHeader>
        <a
          className='item'
          href='https://www.solanamonkeyuniversity.com/#roadmap'
        >
          Roadmap
        </a>
        <a className='item' href='https://www.solanamonkeyuniversity.com/#team'>
          Team
        </a>
        <a href='https://www.solanamonkeyuniversity.com' className='logo'>
          <img src={logo} alt='' />
          <p>SOLANA MONKEY UNIVERSITY</p>
        </a>
        <a
          href='https://www.solanamonkeyuniversity.com/campus'
          className='item'
        >
          CAMPUS
        </a>
        <a
          className='item'
          href='https://www.solanamonkeyuniversity.com/#links'
        >
          LINKS
        </a>
      </StyledHeader>

      <StyledTools>
        <img src={handle} alt='' />
        <a
          href='https://discord.com/invite/smu'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img src={discord} alt='' />
        </a>

        {connected ? (
          <Button
            onClick={() => {
              disconnect();
              sessionStorage.setItem('state', '1');
            }}
          >
            Disconnect Wallet
          </Button>
        ) : (
          <Button
            onClick={() => {
              setOpenWalletModal(true);
              sessionStorage.setItem('state', '1');
            }}
          >
            Connect Wallet
          </Button>
        )}
        <a
          href='https://twitter.com/solanamonkeyuni'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img src={twitter} alt='' />
        </a>
        <img className='handle-right' src={handle} alt='' />
      </StyledTools>
    </>
  );
};
